module.exports = __webpack_public_path__ + "img/booth-hifi.e9984c55.jpg";